import { createUseStyles } from 'react-jss'

export default createUseStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '769px',
    width: '100%'
  }
})
